import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import MDSnackbar from "components/MDSnackbar";

function Notifications() {
  const [successSB, setSuccessSB] = useState(false);
  const [successTitle, setSuccessTitle] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [infoSB, setInfoSB] = useState(false);
  const [infoTitle, setInfoTitle] = useState("");
  const [infoMessage, setInfoMessage] = useState("");

  const [warningSB, setWarningSB] = useState(false);
  const [warningTitle, setWarningTitle] = useState("");
  const [warningMessage, setWarningMessage] = useState("");

  const [errorSB, setErrorSB] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const openSuccessSB = (res) => {
    setSuccessTitle("Success!");
    setSuccessMessage(res?.message);
    setSuccessSB(true);
  };
  const closeSuccessSB = () => {
    setSuccessTitle("");
    setSuccessMessage("");
    setSuccessSB(false);
  };
  const openInfoSB = (res) => {
    setInfoTitle("Info!");
    setInfoMessage(res?.message);
    setInfoSB(true);
  };
  const closeInfoSB = () => {
    setInfoTitle("");
    setInfoMessage("");
    setInfoSB(false);
  };
  const openWarningSB = (res) => {
    setWarningTitle("Warning!");
    setWarningMessage(res?.message);
    setWarningSB(true);
  };
  const closeWarningSB = () => {
    setWarningTitle("");
    setWarningMessage("");
    setWarningSB(false);
  };
  const openErrorSB = (res) => {
    setErrorTitle(res?.error);
    setErrorMessage(res?.message);
    setErrorSB(true);
  };
  const closeErrorSB = () => {
    setErrorTitle("");
    setErrorMessage("");
    setErrorSB(false);
  };

  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title={successTitle}
      content={successMessage}
      dateTime="Now"
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
    />
  );

  const renderInfoSB = (
    <MDSnackbar
      icon="notifications"
      title={infoTitle}
      content={infoMessage}
      dateTime="Now"
      open={infoSB}
      onClose={closeInfoSB}
      close={closeInfoSB}
    />
  );

  const renderWarningSB = (
    <MDSnackbar
      color="warning"
      icon="star"
      title={warningTitle}
      content={warningMessage}
      dateTime="Now"
      open={warningSB}
      onClose={closeWarningSB}
      close={closeWarningSB}
    />
  );

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title={errorMessage}
      content={errorTitle}
      dateTime="Now"
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
    />
  );

  //addons
  const listAddons = useSelector((state) => state.listAddons);
  const { error: listAddonsError } = listAddons;

  useEffect(() => {
    if (listAddonsError) {
      openErrorSB(listAddonsError);
    }
  }, [listAddonsError]);

  const singleAddons = useSelector((state) => state.singleAddons);
  const { error: singleAddonsError } = singleAddons;

  useEffect(() => {
    if (singleAddonsError) {
      openErrorSB(singleAddonsError);
    }
  }, [singleAddonsError]);

  // const addonCreate = useSelector((state) => state.addonCreate);
  // const { error: addonCreateError, newAddon: addonCreateSuccess } = addonCreate;

  // useEffect(() => {
  //   if (addonCreateError) {
  //     openErrorSB(addonCreateError);
  //   }
  // }, [addonCreateError]);

  // useEffect(() => {
  //   if (addonCreateSuccess?.success) {
  //     openSuccessSB(addonCreateSuccess);
  //   }
  // }, [addonCreateSuccess]);

  // const addonUpdate = useSelector((state) => state.addonUpdate);
  // const { error: addonUpdateError, updateAddon: addonUpdateSuccess } =
  //   addonUpdate;

  // useEffect(() => {
  //   if (addonUpdateError) {
  //     openErrorSB(addonUpdateError);
  //   }
  // }, [addonUpdateError]);

  // useEffect(() => {
  //   if (addonUpdateSuccess?.success) {
  //     openSuccessSB(addonUpdateSuccess);
  //   }
  // }, [addonUpdateSuccess]);

  // const addonDelete = useSelector((state) => state.addonDelete);
  // const { error: addonDeleteError, deleteAddon: addonDeleteSuccess } =
  //   addonDelete;

  // useEffect(() => {
  //   if (addonDeleteError) {
  //     openErrorSB(addonDeleteError);
  //   }
  // }, [addonDeleteError]);

  // useEffect(() => {
  //   if (addonDeleteSuccess?.success) {
  //     openSuccessSB(addonDeleteSuccess);
  //   }
  // }, [addonDeleteSuccess]);

  // Categories
  const listCategories = useSelector((state) => state.listCategories);
  const { error: listCategoriesError } = listCategories;

  useEffect(() => {
    if (listCategoriesError) {
      openErrorSB(listCategoriesError);
    }
  }, [listCategoriesError]);

  // const categoryPost = useSelector((state) => state.categoryPost);
  // const { error: categoryPostError, category: categoryPostSuccess } =
  //   categoryPost;

  // useEffect(() => {
  //   if (categoryPostError) {
  //     openErrorSB(categoryPostError);
  //   }
  // }, [categoryPostError]);

  // useEffect(() => {
  //   if (categoryPostSuccess?.success) {
  //     openSuccessSB(categoryPostSuccess);
  //   }
  // }, [categoryPostSuccess]);

  // const updateCategory = useSelector((state) => state.updateCategory);
  // const { error: updateCategoryError, categoryUpdate: updateCategorySuccess } =
  //   updateCategory;

  // useEffect(() => {
  //   if (updateCategoryError) {
  //     openErrorSB(updateCategoryError);
  //   }
  // }, [updateCategoryError]);

  // useEffect(() => {
  //   if (updateCategorySuccess?.success) {
  //     openSuccessSB(updateCategorySuccess);
  //   }
  // }, [updateCategorySuccess]);

  // const deleteCategory = useSelector((state) => state.deleteCategory);
  // const { error: deleteCategoryError, deleteCategory: deleteCategorySuccess } =
  //   deleteCategory;

  // useEffect(() => {
  //   if (deleteCategoryError) {
  //     openErrorSB(deleteCategoryError);
  //   }
  // }, [deleteCategoryError]);

  // useEffect(() => {
  //   if (deleteCategorySuccess?.success) {
  //     openSuccessSB(deleteCategorySuccess);
  //   }
  // }, [deleteCategorySuccess]);

  // Claims
  const myListClaim = useSelector((state) => state.myListClaim);
  const { error: myListClaimError } = myListClaim;

  useEffect(() => {
    if (myListClaimError) {
      openErrorSB(myListClaimError);
    }
  }, [myListClaimError]);

  const statsClaim = useSelector((state) => state.statsClaim);
  const { error: statsClaimError } = statsClaim;

  useEffect(() => {
    if (statsClaimError) {
      openErrorSB(statsClaimError);
    }
  }, [statsClaimError]);

  const singleClaim = useSelector((state) => state.singleClaim);
  const { error: singleClaimError } = singleClaim;

  useEffect(() => {
    if (singleClaimError) {
      openErrorSB(singleClaimError);
    }
  }, [singleClaimError]);

  const pendingClaims = useSelector((state) => state.pendingClaims);
  const { error: pendingClaimsError } = pendingClaims;

  useEffect(() => {
    if (pendingClaimsError) {
      openErrorSB(pendingClaimsError);
    }
  }, [pendingClaimsError]);

  const postClaim = useSelector((state) => state.postClaim);
  const { error: postClaimError, claimsPost: postClaimSuccess } = postClaim;

  useEffect(() => {
    if (postClaimError) {
      openErrorSB(postClaimError);
    }
  }, [postClaimError]);

  useEffect(() => {
    if (postClaimSuccess?.success) {
      openSuccessSB(postClaimSuccess);
    }
  }, [postClaimSuccess]);

  const updateClaims = useSelector((state) => state.updateClaims);
  const { error: updateClaimsError, claimsUpdate: updateClaimsSuccess } =
    updateClaims;

  useEffect(() => {
    if (updateClaimsError) {
      openErrorSB(updateClaimsError);
    }
  }, [updateClaimsError]);

  useEffect(() => {
    if (updateClaimsSuccess?.success) {
      openSuccessSB(updateClaimsSuccess);
    }
  }, [updateClaimsSuccess]);

  const deleteClaims = useSelector((state) => state.deleteClaims);
  const { error: deleteClaimsError, claimsDelete: deleteClaimsSuccess } =
    deleteClaims;

  useEffect(() => {
    if (deleteClaimsError) {
      openErrorSB(deleteClaimsError);
    }
  }, [deleteClaimsError]);

  useEffect(() => {
    if (deleteClaimsSuccess?.success) {
      openSuccessSB(deleteClaimsSuccess);
    }
  }, [deleteClaimsSuccess]);

  // Claims Requirements
  const listClaimRequirements = useSelector(
    (state) => state.listClaimRequirements
  );
  const { error: listClaimRequirementsError } = listClaimRequirements;

  useEffect(() => {
    if (listClaimRequirementsError) {
      openErrorSB(listClaimRequirementsError);
    }
  }, [listClaimRequirementsError]);

  const singleClaimRequirements = useSelector(
    (state) => state.singleClaimRequirements
  );
  const { error: singleClaimRequirementsError } = singleClaimRequirements;

  useEffect(() => {
    if (singleClaimRequirementsError) {
      openErrorSB(singleClaimRequirementsError);
    }
  }, [singleClaimRequirementsError]);

  // const claimRequirementCreate = useSelector(
  //   (state) => state.claimRequirementCreate
  // );
  // const {
  //   error: claimRequirementCreateError,
  //   newClaimRequirement: claimRequirementCreateSuccess,
  // } = claimRequirementCreate;

  // useEffect(() => {
  //   if (claimRequirementCreateError) {
  //     openErrorSB(claimRequirementCreateError);
  //   }
  // }, [claimRequirementCreateError]);

  // useEffect(() => {
  //   if (claimRequirementCreateSuccess?.success) {
  //     openSuccessSB(claimRequirementCreateSuccess);
  //   }
  // }, [claimRequirementCreateSuccess]);

  // const claimRequirementUpdate = useSelector(
  //   (state) => state.claimRequirementUpdate
  // );
  // const {
  //   error: claimRequirementUpdateError,
  //   updateClaimRequirement: claimRequirementUpdateSuccess,
  // } = claimRequirementUpdate;

  // useEffect(() => {
  //   if (claimRequirementUpdateError) {
  //     openErrorSB(claimRequirementUpdateError);
  //   }
  // }, [claimRequirementUpdateError]);

  // useEffect(() => {
  //   if (claimRequirementUpdateSuccess?.success) {
  //     openSuccessSB(claimRequirementUpdateSuccess);
  //   }
  // }, [claimRequirementUpdateSuccess]);

  // const claimRequirementDelete = useSelector(
  //   (state) => state.claimRequirementDelete
  // );
  // const {
  //   error: claimRequirementDeleteError,
  //   deleteClaimRequirement: claimRequirementDeleteSuccess,
  // } = claimRequirementDelete;

  // useEffect(() => {
  //   if (claimRequirementDeleteError) {
  //     openErrorSB(claimRequirementDeleteError);
  //   }
  // }, [claimRequirementDeleteError]);

  // useEffect(() => {
  //   if (claimRequirementDeleteSuccess?.success) {
  //     openSuccessSB(claimRequirementDeleteSuccess);
  //   }
  // }, [claimRequirementDeleteSuccess]);

  // Clients
  const listClients = useSelector((state) => state.listClients);
  const { error: listClientsError } = listClients;

  useEffect(() => {
    if (listClientsError) {
      openErrorSB(listClientsError);
    }
  }, [listClientsError]);

  const singleClient = useSelector((state) => state.singleClient);
  const { error: singleClientError } = singleClient;

  useEffect(() => {
    if (singleClientError) {
      openErrorSB(singleClientError);
    }
  }, [singleClientError]);

  const createClient = useSelector((state) => state.createClient);
  const { error: createClientError, clientCreate: createClientSuccess } =
    createClient;

  useEffect(() => {
    if (createClientError) {
      openErrorSB(createClientError);
    }
  }, [createClientError]);

  useEffect(() => {
    if (createClientSuccess?.success) {
      openSuccessSB(createClientSuccess);
    }
  }, [createClientSuccess]);

  const updateClient = useSelector((state) => state.updateClient);
  const { error: updateClientError, clientUpdate: updateClientSuccess } =
    updateClient;

  useEffect(() => {
    if (updateClientError) {
      openErrorSB(updateClientError);
    }
  }, [updateClientError]);

  useEffect(() => {
    if (updateClientSuccess?.success) {
      openSuccessSB(updateClientSuccess);
    }
  }, [updateClientSuccess]);

  const deleteClient = useSelector((state) => state.deleteClient);
  const { error: deleteClientError, clientDelete: deleteClientSuccess } =
    deleteClient;

  useEffect(() => {
    if (deleteClientError) {
      openErrorSB(deleteClientError);
    }
  }, [deleteClientError]);

  useEffect(() => {
    if (deleteClientSuccess?.success) {
      openSuccessSB(deleteClientSuccess);
    }
  }, [deleteClientSuccess]);

  // Company
  const listCompanies = useSelector((state) => state.listCompanies);
  const { error: listCompaniesError } = listCompanies;

  useEffect(() => {
    if (listCompaniesError) {
      openErrorSB(listCompaniesError);
    }
  }, [listCompaniesError]);

  const singleCompanies = useSelector((state) => state.singleCompanies);
  const { error: singleCompaniesError } = singleCompanies;

  useEffect(() => {
    if (singleCompaniesError) {
      openErrorSB(singleCompaniesError);
    }
  }, [singleCompaniesError]);

  // const companiesPost = useSelector((state) => state.companiesPost);
  // const { error: companiesPostError, companies: companiesPostSuccess } =
  //   companiesPost;

  // useEffect(() => {
  //   if (companiesPostError) {
  //     openErrorSB(companiesPostError);
  //   }
  // }, [companiesPostError]);

  // useEffect(() => {
  //   if (companiesPostSuccess?.success) {
  //     openSuccessSB(companiesPostSuccess);
  //   }
  // }, [companiesPostSuccess]);

  // const updateCompanies = useSelector((state) => state.updateCompanies);
  // const {
  //   error: updateCompaniesError,
  //   companiesUpdate: updateCompaniesSuccess,
  // } = updateCompanies;

  // useEffect(() => {
  //   if (updateCompaniesError) {
  //     openErrorSB(updateCompaniesError);
  //   }
  // }, [updateCompaniesError]);

  // useEffect(() => {
  //   if (updateCompaniesSuccess?.success) {
  //     openSuccessSB(updateCompaniesSuccess);
  //   }
  // }, [updateCompaniesSuccess]);

  // const deleteCompanies = useSelector((state) => state.deleteCompanies);
  // const {
  //   error: deleteCompaniesError,
  //   deleteCompanies: deleteCompaniesSuccess,
  // } = deleteCompanies;

  // useEffect(() => {
  //   if (deleteCompaniesError) {
  //     openErrorSB(deleteCompaniesError);
  //   }
  // }, [deleteCompaniesError]);

  // useEffect(() => {
  //   if (deleteCompaniesSuccess?.success) {
  //     openSuccessSB(deleteCompaniesSuccess);
  //   }
  // }, [deleteCompaniesSuccess]);

  // Info
  const paymentInfo = useSelector((state) => state.paymentInfo);
  const { error: paymentInfoError } = paymentInfo;

  useEffect(() => {
    if (paymentInfoError) {
      openErrorSB(paymentInfoError);
    }
  }, [paymentInfoError]);

  // const updatePaymentInfo = useSelector((state) => state.updatePaymentInfo);
  // const {
  //   error: updatePaymentInfoError,
  //   infoUpdate: updatePaymentInfoSuccess,
  // } = updatePaymentInfo;

  // useEffect(() => {
  //   if (updatePaymentInfoError) {
  //     openErrorSB(updatePaymentInfoError);
  //   }
  // }, [updatePaymentInfoError]);

  // useEffect(() => {
  //   if (updatePaymentInfoSuccess?.success) {
  //     openSuccessSB(updatePaymentInfoSuccess);
  //   }
  // }, [updatePaymentInfoSuccess]);

  // Orders
  const myListOrders = useSelector((state) => state.myListOrders);
  const { error: myListOrdersError } = myListOrders;

  useEffect(() => {
    if (myListOrdersError) {
      openErrorSB(myListOrdersError);
    }
  }, [myListOrdersError]);

  const statsOrders = useSelector((state) => state.statsOrders);
  const { error: statsOrdersError } = statsOrders;

  useEffect(() => {
    if (statsOrdersError) {
      openErrorSB(statsOrdersError);
    }
  }, [statsOrdersError]);

  const orderSingle = useSelector((state) => state.orderSingle);
  const { error: orderSingleError } = orderSingle;

  useEffect(() => {
    if (orderSingleError) {
      openErrorSB(orderSingleError);
    }
  }, [orderSingleError]);

  const createOrder = useSelector((state) => state.createOrder);
  const { error: createOrderError, orderCreate: createOrderSuccess } =
    createOrder;

  useEffect(() => {
    if (createOrderError) {
      openErrorSB(createOrderError);
    }
  }, [createOrderError]);

  useEffect(() => {
    if (createOrderSuccess?.success) {
      openSuccessSB(createOrderSuccess);
    }
  }, [createOrderSuccess]);

  const updateOrder = useSelector((state) => state.updateOrder);
  const { error: updateOrderError, orderUpdate: updateOrderSuccess } =
    updateOrder;

  useEffect(() => {
    if (updateOrderError) {
      openErrorSB(updateOrderError);
    }
  }, [updateOrderError]);

  useEffect(() => {
    if (updateOrderSuccess?.success) {
      openSuccessSB(updateOrderSuccess);
    }
  }, [updateOrderSuccess]);

  const deleteOrder = useSelector((state) => state.deleteOrder);
  const { error: deleteOrderError, orderDelete: deleteOrderSuccess } =
    deleteOrder;

  useEffect(() => {
    if (deleteOrderError) {
      openErrorSB(deleteOrderError);
    }
  }, [deleteOrderError]);

  useEffect(() => {
    if (deleteOrderSuccess?.success) {
      openSuccessSB(deleteOrderSuccess);
    }
  }, [deleteOrderSuccess]);

  const listIncompleteOrders = useSelector(
    (state) => state.listIncompleteOrders
  );
  const { error: listIncompleteOrdersError } = listIncompleteOrders;

  useEffect(() => {
    if (listIncompleteOrdersError) {
      openErrorSB(listIncompleteOrdersError);
    }
  }, [listIncompleteOrdersError]);

  const listApprovedOrders = useSelector((state) => state.listApprovedOrders);
  const { error: listApprovedOrdersError } = listApprovedOrders;

  useEffect(() => {
    if (listApprovedOrdersError) {
      openErrorSB(listApprovedOrdersError);
    }
  }, [listApprovedOrdersError]);

  const listShippingOrder = useSelector((state) => state.listShippingOrder);
  const { error: listShippingOrderError } = listShippingOrder;

  useEffect(() => {
    if (listShippingOrderError) {
      openErrorSB(listShippingOrderError);
    }
  }, [listShippingOrderError]);

  const listDeliveriesOrders = useSelector(
    (state) => state.listDeliveriesOrders
  );
  const { error: listDeliveriesOrdersError } = listDeliveriesOrders;

  useEffect(() => {
    if (listDeliveriesOrdersError) {
      openErrorSB(listDeliveriesOrdersError);
    }
  }, [listDeliveriesOrdersError]);

  // Policies
  const listPolicies = useSelector((state) => state.listPolicies);
  const { error: listPoliciesError } = listPolicies;

  useEffect(() => {
    if (listPoliciesError) {
      openErrorSB(listPoliciesError);
    }
  }, [listPoliciesError]);

  const statsPolicies = useSelector((state) => state.statsPolicies);
  const { error: statsPoliciesError } = statsPolicies;

  useEffect(() => {
    if (statsPoliciesError) {
      openErrorSB(statsPoliciesError);
    }
  }, [statsPoliciesError]);

    const searchPolicies = useSelector((state) => state.searchPolicies);
  const { error: searchPoliciesError } = searchPolicies;

  useEffect(() => {
    if (searchPoliciesError) {
      openErrorSB(searchPoliciesError);
    }
  }, [searchPoliciesError]);

  const singlePolicy = useSelector((state) => state.singlePolicy);
  const { error: singlePolicyError } = singlePolicy;

  useEffect(() => {
    if (singlePolicyError) {
      openErrorSB(singlePolicyError);
    }
  }, [singlePolicyError]);

  const listPoliciesPerCategory = useSelector(
    (state) => state.listPoliciesPerCategory
  );
  const { error: listPoliciesPerCategoryError } = listPoliciesPerCategory;

  useEffect(() => {
    if (listPoliciesPerCategoryError) {
      openErrorSB(listPoliciesPerCategoryError);
    }
  }, [listPoliciesPerCategoryError]);

  // const createPolicy = useSelector((state) => state.createPolicy);
  // const { error: createPolicyError, policyCreate: createPolicySuccess } =
  //   createPolicy;

  // useEffect(() => {
  //   if (createPolicyError) {
  //     openErrorSB(createPolicyError);
  //   }
  // }, [createPolicyError]);

  // useEffect(() => {
  //   if (createPolicySuccess?.success) {
  //     openSuccessSB(createPolicySuccess);
  //   }
  // }, [createPolicySuccess]);

  // const updatePolicy = useSelector((state) => state.updatePolicy);
  // const { error: updatePolicyError, policyUpdate: updatePolicySuccess } =
  //   updatePolicy;

  // useEffect(() => {
  //   if (updatePolicyError) {
  //     openErrorSB(updatePolicyError);
  //   }
  // }, [updatePolicyError]);

  // useEffect(() => {
  //   if (updatePolicySuccess?.success) {
  //     openSuccessSB(updatePolicySuccess);
  //   }
  // }, [updatePolicySuccess]);

  // const deletePolicy = useSelector((state) => state.deletePolicy);
  // const { error: deletePolicyError, policyDelete: deletePolicySuccess } =
  //   deletePolicy;

  // useEffect(() => {
  //   if (deletePolicyError) {
  //     openErrorSB(deletePolicyError);
  //   }
  // }, [deletePolicyError]);

  // useEffect(() => {
  //   if (deletePolicySuccess?.success) {
  //     openSuccessSB(deletePolicySuccess);
  //   }
  // }, [deletePolicySuccess]);

  // Policy Requirements
  const listPolicyRequirements = useSelector(
    (state) => state.listPolicyRequirements
  );
  const { error: listPolicyRequirementsError } = listPolicyRequirements;

  useEffect(() => {
    if (listPolicyRequirementsError) {
      openErrorSB(listPolicyRequirementsError);
    }
  }, [listPolicyRequirementsError]);

  const singlePolicyRequirements = useSelector(
    (state) => state.singlePolicyRequirements
  );
  const { error: singlePolicyRequirementsError } = singlePolicyRequirements;

  useEffect(() => {
    if (singlePolicyRequirementsError) {
      openErrorSB(singlePolicyRequirementsError);
    }
  }, [singlePolicyRequirementsError]);

  // const policyRequirementCreate = useSelector(
  //   (state) => state.policyRequirementCreate
  // );
  // const {
  //   error: policyRequirementCreateError,
  //   newPolicyRequirement: policyRequirementCreateSuccess,
  // } = policyRequirementCreate;

  // useEffect(() => {
  //   if (policyRequirementCreateError) {
  //     openErrorSB(policyRequirementCreateError);
  //   }
  // }, [policyRequirementCreateError]);

  // useEffect(() => {
  //   if (policyRequirementCreateSuccess?.success) {
  //     openSuccessSB(policyRequirementCreateSuccess);
  //   }
  // }, [policyRequirementCreateSuccess]);

  // const policyRequirementUpdate = useSelector(
  //   (state) => state.policyRequirementUpdate
  // );
  // const {
  //   error: policyRequirementUpdateError,
  //   updatePolicyRequirement: policyRequirementUpdateSuccess,
  // } = policyRequirementUpdate;

  // useEffect(() => {
  //   if (policyRequirementUpdateError) {
  //     openErrorSB(policyRequirementUpdateError);
  //   }
  // }, [policyRequirementUpdateError]);

  // useEffect(() => {
  //   if (policyRequirementUpdateSuccess?.success) {
  //     openSuccessSB(policyRequirementUpdateSuccess);
  //   }
  // }, [policyRequirementUpdateSuccess]);

  // const policyRequirementDelete = useSelector(
  //   (state) => state.policyRequirementDelete
  // );
  // const {
  //   error: policyRequirementDeleteError,
  //   deletePolicyRequirement: policyRequirementDeleteSuccess,
  // } = policyRequirementDelete;

  // useEffect(() => {
  //   if (policyRequirementDeleteError) {
  //     openErrorSB(policyRequirementDeleteError);
  //   }
  // }, [policyRequirementDeleteError]);

  // useEffect(() => {
  //   if (policyRequirementDeleteSuccess?.success) {
  //     openSuccessSB(policyRequirementDeleteSuccess);
  //   }
  // }, [policyRequirementDeleteSuccess]);

  // Response Requirements
  const listResponsePerClientRequirements = useSelector(
    (state) => state.listResponsePerClientRequirements
  );
  const { error: listResponsePerClientRequirementsError } =
    listResponsePerClientRequirements;

  useEffect(() => {
    if (listResponsePerClientRequirementsError) {
      openErrorSB(listResponsePerClientRequirementsError);
    }
  }, [listResponsePerClientRequirementsError]);

  const singleResponseRequirements = useSelector(
    (state) => state.singleResponseRequirements
  );
  const { error: singleResponseRequirementsError } = singleResponseRequirements;

  useEffect(() => {
    if (singleResponseRequirementsError) {
      openErrorSB(singleResponseRequirementsError);
    }
  }, [singleResponseRequirementsError]);

  const responseRequirementCreate = useSelector(
    (state) => state.responseRequirementCreate
  );
  const {
    error: responseRequirementCreateError,
    newResponseRequirement: responseRequirementCreateSuccess,
  } = responseRequirementCreate;

  useEffect(() => {
    if (responseRequirementCreateError) {
      openErrorSB(responseRequirementCreateError);
    }
  }, [responseRequirementCreateError]);

  useEffect(() => {
    if (responseRequirementCreateSuccess?.success) {
      openSuccessSB(responseRequirementCreateSuccess);
    }
  }, [responseRequirementCreateSuccess]);

  const responseRequirementUpdate = useSelector(
    (state) => state.responseRequirementUpdate
  );
  const {
    error: responseRequirementUpdateError,
    updateResponseRequirement: responseRequirementUpdateSuccess,
  } = responseRequirementUpdate;

  useEffect(() => {
    if (responseRequirementUpdateError) {
      openErrorSB(responseRequirementUpdateError);
    }
  }, [responseRequirementUpdateError]);

  useEffect(() => {
    if (responseRequirementUpdateSuccess?.success) {
      openSuccessSB(responseRequirementUpdateSuccess);
    }
  }, [responseRequirementUpdateSuccess]);

  const responseRequirementDelete = useSelector(
    (state) => state.responseRequirementDelete
  );
  const {
    error: responseRequirementDeleteError,
    deleteResponseRequirement: responseRequirementDeleteSuccess,
  } = responseRequirementDelete;

  useEffect(() => {
    if (responseRequirementDeleteError) {
      openErrorSB(responseRequirementDeleteError);
    }
  }, [responseRequirementDeleteError]);

  useEffect(() => {
    if (responseRequirementDeleteSuccess?.success) {
      openSuccessSB(responseRequirementDeleteSuccess);
    }
  }, [responseRequirementDeleteSuccess]);

  // Transactions
  const myListTransactions = useSelector((state) => state.myListTransactions);
  const { error: myListTransactionsError } = myListTransactions;

  useEffect(() => {
    if (myListTransactionsError) {
      openErrorSB(myListTransactionsError);
    }
  }, [myListTransactionsError]);

  const statsTransactions = useSelector((state) => state.statsTransactions);
  const { error: statsTransactionsError } = statsTransactions;

  useEffect(() => {
    if (statsTransactionsError) {
      openErrorSB(statsTransactionsError);
    }
  }, [statsTransactionsError]);

  const incompleteTransactions = useSelector(
    (state) => state.incompleteTransactions
  );
  const { error: incompleteTransactionsError } = incompleteTransactions;

  useEffect(() => {
    if (incompleteTransactionsError) {
      openErrorSB(incompleteTransactionsError);
    }
  }, [incompleteTransactionsError]);

  const orderTransaction = useSelector((state) => state.orderTransaction);
  const { error: orderTransactionError } = orderTransaction;

  useEffect(() => {
    if (orderTransactionError) {
      openErrorSB(orderTransactionError);
    }
  }, [orderTransactionError]);

  const singleTransaction = useSelector((state) => state.singleTransaction);
  const { error: singleTransactionError } = singleTransaction;

  useEffect(() => {
    if (singleTransactionError) {
      openErrorSB(singleTransactionError);
    }
  }, [singleTransactionError]);

  const createTransaction = useSelector((state) => state.createTransaction);
  const {
    error: createTransactionError,
    transactionCreate: createTransactionSuccess,
  } = createTransaction;

  useEffect(() => {
    if (createTransactionError) {
      openErrorSB(createTransactionError);
    }
  }, [createTransactionError]);

  useEffect(() => {
    if (createTransactionSuccess?.success) {
      openSuccessSB(createTransactionSuccess);
    }
  }, [createTransactionSuccess]);

  const updateTransaction = useSelector((state) => state.updateTransaction);
  const {
    error: updateTransactionError,
    transactionUpdate: updateTransactionSuccess,
  } = updateTransaction;

  useEffect(() => {
    if (updateTransactionError) {
      openErrorSB(updateTransactionError);
    }
  }, [updateTransactionError]);

  useEffect(() => {
    if (updateTransactionSuccess?.success) {
      openSuccessSB(updateTransactionSuccess);
    }
  }, [updateTransactionSuccess]);

  const deleteTransaction = useSelector((state) => state.deleteTransaction);
  const {
    error: deleteTransactionError,
    transactionDelete: deleteTransactionSuccess,
  } = deleteTransaction;

  useEffect(() => {
    if (deleteTransactionError) {
      openErrorSB(deleteTransactionError);
    }
  }, [deleteTransactionError]);

  useEffect(() => {
    if (deleteTransactionSuccess?.success) {
      openSuccessSB(deleteTransactionSuccess);
    }
  }, [deleteTransactionSuccess]);

  // User / Admin
  const listUsers = useSelector((state) => state.listUsers);
  const { error: listUsersError } = listUsers;

  useEffect(() => {
    if (listUsersError) {
      openErrorSB(listUsersError);
    }
  }, [listUsersError]);

  const singleUser = useSelector((state) => state.singleUser);
  const { error: singleUserError } = singleUser;

  useEffect(() => {
    if (singleUserError) {
      openErrorSB(singleUserError);
    }
  }, [singleUserError]);

  const createUser = useSelector((state) => state.createUser);
  const { error: createUserError, userCreate: createUserSuccess } = createUser;

  useEffect(() => {
    if (createUserError) {
      openErrorSB(createUserError);
    }
  }, [createUserError]);

  useEffect(() => {
    if (createUserSuccess?.success) {
      openSuccessSB(createUserSuccess);
    }
  }, [createUserSuccess]);

  const updateUser = useSelector((state) => state.updateUser);
  const { error: updateUserError, userUpdate: updateUserSuccess } = updateUser;

  useEffect(() => {
    if (updateUserError) {
      openErrorSB(updateUserError);
    }
  }, [updateUserError]);

  useEffect(() => {
    if (updateUserSuccess?.success) {
      openSuccessSB(updateUserSuccess);
    }
  }, [updateUserSuccess]);

  const deleteUser = useSelector((state) => state.deleteUser);
  const { error: deleteUserError, userDelete: deleteUserSuccess } = deleteUser;

  useEffect(() => {
    if (deleteUserError) {
      openErrorSB(deleteUserError);
    }
  }, [deleteUserError]);

  useEffect(() => {
    if (deleteUserSuccess?.success) {
      openSuccessSB(deleteUserSuccess);
    }
  }, [deleteUserSuccess]);

  // Company Stats
  const companyStats = useSelector((state) => state.companyStats);
  const { error: companyStatsError } = companyStats;

  useEffect(() => {
    if (companyStatsError) {
      openErrorSB(companyStatsError);
    }
  }, [companyStatsError]);

  const statsByAge = useSelector((state) => state.statsByAge);
  const { error: ageStatsError } = statsByAge;

  useEffect(() => {
    if (ageStatsError) {
      openErrorSB(ageStatsError);
    }
  }, [ageStatsError]);

  const statsClientsJoinedPerMonth = useSelector(
    (state) => state.statsClientsJoinedPerMonth
  );
  const { error: clientsJoinedPerMonthError } = statsClientsJoinedPerMonth;

  useEffect(() => {
    if (clientsJoinedPerMonthError) {
      openErrorSB(clientsJoinedPerMonthError);
    }
  }, [clientsJoinedPerMonthError]);

  const statsNewOrdersPerMonth = useSelector(
    (state) => state.statsNewOrdersPerMonth
  );
  const { error: statsNewOrdersPerMonthError } = statsNewOrdersPerMonth;

  useEffect(() => {
    if (statsNewOrdersPerMonthError) {
      openErrorSB(statsNewOrdersPerMonthError);
    }
  }, [statsNewOrdersPerMonthError]);

  const polComCatCliTopPerforming = useSelector(
    (state) => state.polComCatCliTopPerforming
  );
  const { error: polComCatCliTopPerformingError } = polComCatCliTopPerforming;

  useEffect(() => {
    if (polComCatCliTopPerformingError) {
      openErrorSB(polComCatCliTopPerformingError);
    }
  }, [polComCatCliTopPerformingError]);

  const overallCompanyStats = useSelector((state) => state.overallCompanyStats);
  const { error: companyStatsOverallError } = overallCompanyStats;

  useEffect(() => {
    if (companyStatsOverallError) {
      openErrorSB(companyStatsOverallError);
    }
  }, [companyStatsOverallError]);

  return (
    <>
      {successSB && renderSuccessSB}
      {infoSB && renderInfoSB}
      {warningSB && renderWarningSB}
      {errorSB && renderErrorSB}
    </>
  );
}

export default Notifications;
